module.exports = __webpack_public_path__ + "db90f10b7688c72d777bf89dd580616e.pdf";